<div class="page-header report-header">{{ 'reports.reportGenerator.header' | xTranslate | titlecase }}</div>
<div class="report-generator-container">
  <div *ngIf="$isLoading()" class="report-generator-loader">
    <cbre-spinner-loading-indicator
      [description]="'reports.reportGenerator.loading' | xTranslate"
      [diameter]="48"
    ></cbre-spinner-loading-indicator>
  </div>

  <div *ngIf="$hasError() && !$isLoading()" class="report-generator-error">
    <miq-error-page-st></miq-error-page-st>
  </div>

  <miq-react-embedded
    *ngIf="!$isLoading() && !$hasError() && $props()"
    [reactAppUrl]="baseUrl"
    [scriptPath]="jsPath"
    [cssPath]="cssPath"
    [props]="$props()"
    (handleError)="onErrorWhenEmbedding()"
  >
  </miq-react-embedded>
</div>
